// I suggerimenti mentre citi: prima quale paragrafo, poi in che forma.
//
// Le citazioni di md2pdf sono `§id` e `§id:selettore`. Gli id li conosce solo
// il documento — sono i `§` in fondo ai titoli — e ricordarseli a memoria
// mentre scrivi è il modo sicuro per scriverne uno che non esiste e scoprirlo
// solo alla composizione. Qui li propone l'editor, letti dal documento stesso.

import { type Completion, type CompletionContext, type CompletionResult } from "@codemirror/autocomplete";

import { leggiParagrafi } from "./paragrafi";


// Le forme che l'engine sa rendere, con l'aria che hanno nel PDF.
const SELETTORI: Completion[] = [
    // In cima: è la forma con cui è scritto tutto il manuale, quindi è quella
    // che nove volte su dieci stai cercando.
    { label: "chapter-page", detail: "14.1 (pag. 122)", info: "numero di capitolo e pagina — la forma usata nel manuale", boost: 1 },
    { label: "chapter", detail: "14.1", info: "solo il numero di capitolo" },
    { label: "page", detail: "122", info: "solo il numero di pagina" },
    { label: "title", detail: "«Titolo del capitolo»", info: "il titolo, tra virgolette" },
];

const CITAZIONE = /§[A-Za-z][A-Za-z0-9_.-]*:[a-z-]*/;
const IDENTIFICATORE = /§[A-Za-z0-9_.-]*/;


// Su una riga di TITOLO il § non è una citazione: è la definizione dell'ancora
// di quel capitolo. Proporre lì l'elenco dei paragrafi esistenti è offrire
// esattamente gli id che NON puoi usare — sono già presi — e per giunta un
// invio distratto ne scriverebbe uno duplicato.
const TITOLO = /^\s{0,3}#{1,6}\s/;


export function suggerimenti(ctx: CompletionContext): CompletionResult | null
{
    const riga = ctx.state.doc.lineAt(ctx.pos);

    if (TITOLO.test(riga.text)) { return null; }

    // Prima il selettore: `§panoramica:` è già una citazione, e quello che
    // manca è la forma. Va provato per primo, perché contiene anche l'id.
    const selettore = ctx.matchBefore(CITAZIONE);

    if (selettore !== null)
    {
        return {
            from: selettore.from + selettore.text.indexOf(":") + 1,
            options: SELETTORI,
            validFor: /^[a-z-]*$/,
        };
    }

    const citazione = ctx.matchBefore(IDENTIFICATORE);

    if (citazione === null) { return null; }

    // Il documento è la sola fonte: un elenco a parte divergerebbe proprio
    // mentre lo stai usando.
    const paragrafi = leggiParagrafi(ctx.state.doc.toString());

    if (paragrafi.length === 0) { return null; }

    return {
        from: citazione.from + 1,
        options: paragrafi.map((p) => ({
            label: p.id,
            detail: p.titolo,
            info: `riga ${p.riga}`,
            type: "constant",
        })),
        validFor: /^[A-Za-z0-9_.-]*$/,
    };
}
